import React, { Fragment, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import MetaTags from "react-meta-tags";
import Loading from "../blocks/loading/Loading";
import Header from "../blocks/header/Header";
import Footer from "../blocks/footer/Footer";
import PageTitleCommon from "../blocks/page-title/PageTitleCommon";
import { Alert, Button, Card, Table } from "antd";
import TextArea from "antd/es/input/TextArea";

const LiveTrackingTruckGoogleMap = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const initialResi = queryParams.get("resi") || "";
  const [liveLoc, setLiveLoc] = useState("none");
  const [trackingNumber, setTrackingNumber] = useState("");
  const [trackingSuccess, setTrackingSuccess] = useState(false);
  const [trackingError, setTrackingError] = useState(false);

  const handleInputChange = (e) => {
    setTrackingNumber(e.target.value);
    setTrackingError(false);
  };

  const handleTrackingSubmit = () => {
    if (!trackingNumber.trim() && !initialResi) {
      setTrackingError(true);
      setLiveLoc("none");
      return;
    }
    setLiveLoc("block");
    setTrackingSuccess(true);
    setTrackingError(false);
  };

  useEffect(() => {
    if (initialResi) {
      handleTrackingSubmit();
    }
  });

  const trackingDetails = {
    resi: "ILIEX0912819000",
    courier: "ILI EXPRESS",
    pelayanan: "EXPRESS CARGO",
    waktuPengiriman: "20 Jan, 11:57 pm",
    pengirim: "Ade, Mr. - Guangzhou, China",
    tujuan: "Imanuel, Mr. - Medan, Sumatera Utara",
    statusTerakhir: [
      {
        tanggal: "8 Apr, 5:59 am",
        keterangan: "Shipment information received",
      },
      { tanggal: "8 Apr, 8:59 am", keterangan: "Picked up" },
      {
        tanggal: "9 Apr, 1:59 am",
        keterangan: "Processed at [GuangZhou Warehouse]",
      },
      {
        tanggal: "9 Apr, 2:00 pm",
        keterangan: "Departed from [BIA - GuangZhou]",
      },
      { tanggal: "10 Apr, 5:59 am", keterangan: "Arrived at [CGK - Jakarta]" },
      {
        tanggal: "10 Apr, 10:59 am",
        keterangan: "Customs clearance status updated",
        details: [
          { status: "DOKUMEN DITERIMA UNTUK DIPROSES BEA CUKAI" },
          { status: "CEK DATA WAJIB SELESAI" },
          { status: "PROSES VALIDASI SISTEM BEA CUKAI" },
          { status: "SELESAI VALIDASI SISTEM BEA CUKAI" },
          { status: "PENELITIAN OLEH PEJABAT BEA CUKAI" },
          {
            status:
              "BARANG AKAN DIPERIKSA FISIK, MENUNGGU PENYIAPAN BARANG OLEH PENYELENGGARA POS",
          },
          {
            status:
              "PERSETUJUAN KELUAR DENGAN PEMBEBASAN BEA MASUK DAN PAJAK, PENERIMA BARANG SILAHKAN KONFIRMASI KE PENYELENGGARA POS/PJT",
          },
          { status: "PERSETUJUAN KELUAR (SPPB)" },
        ],
      },
      { tanggal: "11 Apr, 1:00 am", keterangan: "Customs clearance completed" },
      { tanggal: "11 Apr, 5:59 am", keterangan: "In transit" },
      { tanggal: "12 Apr, 5:59 am", keterangan: "Out for delivery" },
    ],
  };

  const columns = [
    {
      title: "Date/Time",
      dataIndex: "tanggal",
      key: "tanggal",
      render: (text) => <span style={{ color: "#0050B3" }}>{text}</span>,
    },
    {
      title: "Description",
      dataIndex: "keterangan",
      key: "keterangan",
    },
  ];

  const customsClearance = trackingDetails.statusTerakhir.find(
    (status) => status.keterangan === "Customs clearance status updated"
  );

  return (
    <Fragment>
      <MetaTags>
        <title>Tracking | ILI EXPRESS</title>
      </MetaTags>
      <Loading />
      <Header logoColor="dark" />
      <main id="main" className="site-main">
        <PageTitleCommon title="Tracking" />
        <section id="page-content" className="block spacer p-top-md">
          <div className="wrapper">
            <div className="content">
              <div id="tracking">
                <div className="row gutter-width-md single-content">
                  <div className="col-xl-7 col-lg-8 col-md-12">
                    <Card
                      title="TRACK YOUR SHIPMENT HERE"
                      bordered={false}
                      className="mb-12 shadow-sm"
                    >
                      <TextArea
                        placeholder="Input Shipments by Number"
                        value={trackingNumber}
                        onChange={handleInputChange}
                        style={{
                          borderRadius: "6px",
                          borderColor: trackingError ? "#FF4D4F" : "#D9D9D9",
                        }}
                      />
                      {trackingError && (
                        <Alert
                          message="Nomor Resi Tidak Boleh Kosong!"
                          type="error"
                          showIcon
                        />
                      )}
                      <Button
                        type="primary"
                        block
                        onClick={handleTrackingSubmit}
                        style={{ backgroundColor: "#FFC107" }}
                        className="mt-3"
                      >
                        Find Your Package
                      </Button>
                    </Card>
                    {trackingSuccess && (
                      <Card bordered={false} className="shadow-sm">
                        <div className="row">
                          <div className="col-lg-3">
                            <b>Shipment Number :</b> <br />
                            {trackingDetails.resi}
                          </div>
                          <div className="col-lg-3">
                            <b>Courier :</b> <br />
                            {trackingDetails.courier}
                          </div>
                          <div className="col-lg-3">
                            <b>Service :</b> <br />
                            {trackingDetails.pelayanan}
                          </div>
                          <div className="col-lg-3">
                            <b>Delivery at :</b> <br />
                            {trackingDetails.waktuPengiriman}
                          </div>
                        </div>

                        <div className="row mt-4">
                          <div className="col-lg-6">
                            <b>From :</b> <br />
                            {trackingDetails.pengirim}
                          </div>
                          <div className="col-lg-6">
                            <b>To :</b> <br />
                            {trackingDetails.tujuan}
                          </div>
                        </div>
                        <Table
                          style={{ marginTop: "20px" }}
                          columns={columns}
                          dataSource={trackingDetails.statusTerakhir}
                          pagination={false}
                          bordered
                          rowKey={(record) => record.tanggal}
                        />
                      </Card>
                    )}
                  </div>
                  <div
                    className="col-xl-5 col-lg-4 col-md-12"
                    style={{ display: liveLoc }}
                  >
                    <Card
                      title="LIVE TRACKING"
                      bordered={false}
                      className="mb-12 shadow-sm"
                    >
                      <iframe
                        src="https://order-tracking-staging.transtrack.id/iframe/live-location/vehicles?api_key=key-QzKVk5cd5sYSH18vDiAytEdzInQWMVdLvdHjZrDpfaZjiyrwm849vg8mdMih0TlY&keys=B 2030 FKX"
                        width="100%"
                        height="400px"
                        style={{ border: "none", borderRadius: "8px" }}
                        title="Live Location Tracking"
                      ></iframe>
                    </Card>
                    {customsClearance && (
                      <Card
                        style={{ marginTop: "60px" }}
                        title="CUSTOMS CLEARANCE"
                        bordered={false}
                        className="mb-12 shadow-sm"
                      >
                        <ul>
                          {customsClearance.details.map((item, index) => (
                            <li
                              key={index}
                              style={{ fontWeight: "normal", color: "#0050B3" }}
                            >
                              {item.status}
                            </li>
                          ))}
                        </ul>
                      </Card>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </Fragment>
  );
};
export default LiveTrackingTruckGoogleMap;
